export const loadPendoScript = (apiKey: string, cspNonce: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (globalThis.pendo) return resolve();

    const script = document.createElement('script');
    script.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
    script.nonce = cspNonce;
    script.async = true;

    script.onerror = () => {
      reject(new Error('Pendo failed to load. This is often caused by an AdBlocker or a strict CSP.'));
    };
    script.onload = () => resolve();
    document.head.appendChild(script);
  });
};
